import { FixedBlockType } from '../types/block-type';
import { addNewBlock } from '../utils/add-new-block';
import { comparatorTypeTranslate, TimeUnit, timeUnitTranslate, } from '../utils/translates';
import { Comparator } from 'z3k-config';
function addTimeComparatorBlock(color_of_logic_blocks) {
    const block = {
        message0: 'Текущее время %1 %2 : %3',
        args0: [
            {
                type: 'field_dropdown',
                name: 'comparator_type',
                options: [
                    [
                        comparatorTypeTranslate[Comparator.Type.LESS],
                        Comparator.Type.LESS.toString(),
                    ],
                    [
                        comparatorTypeTranslate[Comparator.Type.MORE],
                        Comparator.Type.MORE.toString(),
                    ],
                    [
                        comparatorTypeTranslate[Comparator.Type.EQUAL],
                        Comparator.Type.EQUAL.toString(),
                    ],
                    [
                        comparatorTypeTranslate[Comparator.Type.LESS_OR_EQUAL],
                        Comparator.Type.LESS_OR_EQUAL.toString(),
                    ],
                    [
                        comparatorTypeTranslate[Comparator.Type.MORE_OR_EQUAL],
                        Comparator.Type.MORE_OR_EQUAL.toString(),
                    ],
                ],
            },
            {
                type: 'field_number',
                name: 'hour',
                value: 0,
                min: 0,
                max: 23,
            },
            {
                type: 'field_number',
                name: 'min',
                value: 0,
                min: 0,
                max: 59,
            },
        ],
        output: 'Boolean',
        colour: color_of_logic_blocks, //20
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.time_comparator, block);
    return FixedBlockType.time_comparator;
}
function addWeekDaysInputBlock(color_of_logic_blocks) {
    const block = {
        message0: 'День недели: %1 %2Пн \u2800 %3Вт \u2800 %4Ср \u2800 %5Чт \u2800 %6Пт \u2800 %7Сб \u2800 %8Вс',
        args0: [
            {
                type: 'input_dummy',
            },
            {
                type: 'field_checkbox',
                name: 'Mo',
                checked: true,
            },
            {
                type: 'field_checkbox',
                name: 'Tu',
                checked: true,
            },
            {
                type: 'field_checkbox',
                name: 'We',
                checked: true,
            },
            {
                type: 'field_checkbox',
                name: 'Th',
                checked: true,
            },
            {
                type: 'field_checkbox',
                name: 'Fr',
                checked: true,
            },
            {
                type: 'field_checkbox',
                name: 'Sa',
                checked: true,
            },
            {
                type: 'field_checkbox',
                name: 'Su',
                checked: true,
            },
        ],
        inputsInline: false,
        output: 'Boolean',
        colour: color_of_logic_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.weekdays_input, block);
    return FixedBlockType.weekdays_input;
}
function addPauseBlock(color_of_logic_blocks) {
    const block = {
        message0: 'Пауза %1 %2',
        args0: [
            {
                type: 'field_number',
                name: 'value',
                value: 0,
                min: 0,
            },
            {
                type: 'field_dropdown',
                name: 'unit_time',
                options: [
                    [timeUnitTranslate[TimeUnit.SEC], TimeUnit.SEC.toString()],
                    [timeUnitTranslate[TimeUnit.MIN], TimeUnit.MIN.toString()],
                    [timeUnitTranslate[TimeUnit.HOUR], TimeUnit.HOUR.toString()],
                    [timeUnitTranslate[TimeUnit.DAY], TimeUnit.DAY.toString()],
                ],
            },
        ],
        previousStatement: null,
        nextStatement: null,
        colour: color_of_logic_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.pause, block);
    return FixedBlockType.pause;
}
export function generateTimeComparatorBlocks(color_of_logic_blocks) {
    return [addTimeComparatorBlock, addWeekDaysInputBlock, addPauseBlock].map((func) => func(color_of_logic_blocks));
}
